import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
export const AlertDialog = ({ title, message, buttonLabels, open, onClose }) => {
    if (!buttonLabels || buttonLabels.length === 0) {
        buttonLabels = ['OK'];
    }
    return (React.createElement(Dialog, { open: open, onClose: () => {
            if (onClose)
                onClose(0);
        } },
        React.createElement(DialogTitle, null, title),
        React.createElement(DialogContent, null,
            React.createElement(Typography, { variant: 'body2' }, message)),
        React.createElement(DialogActions, null, buttonLabels.map((label, index) => (React.createElement(Button, { variant: 'contained', color: 'primary', key: index, onClick: () => {
                if (onClose)
                    onClose(index);
            } }, label))))));
};
export default AlertDialog;
//# sourceMappingURL=AlertDialog.js.map